<template>
  <i18n-link
    :to="{
      name: routeName,
      params: { slug: slug },
      query: statusQuery
    }"
    :class="$style.root"
    :data-current="current ? '' : null"
  >
    {{ label }}
  </i18n-link>
</template>

<script setup>
const props = defineProps({
  routeName: {
    type: String,
    required: true
  },
  label: {
    type: [String, Number],
    required: true
  },
  slug: {
    type: String,
    required: true
  }
})

const current = computed(() => props?.routeName === getRouteName())

const statusQuery = getStatusQuery()
</script>

<style module>
.root {
  composes: reset-link button-rectangular from global;
  display: block;
}
</style>
